const backgroundOpacity = (state = false, action)=>{
    if(action.type === "SET_BG_OPACITY"){
        state = action.state
    }
    return state;
}

export default backgroundOpacity;
